<template lang="">
  <div class="md:w-4/12 md:mx-2 w-full">
    <button class="btn btn-blue-hollow mt-3 block w-full relative"> {{ $t("payment-type-paypal") }}<span ref="forpaypal" class="inset-0 absolute opacity-0"></span></button>
    <p class="text-12 red" v-html="errorNote" v-if="errorNote"></p>
  </div>
</template>
<script>
import * as TinabaAPI from '@/common/TinabaAPI'
import { getformattedLocale } from '@/i18n'
import linkToPayData from '@/mixins/linkToPayData.js'
export default {
  mixins: [linkToPayData],
  data () {
    return {
      processing: false,
      paypalActions: null,
      errorNote: null
    }
  },
  methods: {
    initPaypal () {
      window.paypal.Buttons({
        locale: getformattedLocale(),
        style: {
          height: 45,
          layout:  'horizontal',
          size: 'responsive',
          shape: 'rect',
          color: 'gold'
        },
        createOrder: (data, actions) => {
          return TinabaAPI.createPaypalCheckout(this.payment.id, 'WALLET')
          .then(({ data }) => {
            if (data.message) {
              this.errorNote = data.message
              console.log(data.message)
              return null
            }
            this.setGlobalLoading()
            return data.externalTransactionId
          })
        },
        onInit: (data, actions) => {
          this.paypalActions = actions
        },
        onError: () => {
          this.processing = false
          this.unsetGlobalLoading()
        },
        onCancel: () => {
          this.processing = false
          this.unsetGlobalLoading()
        },
        onApprove: (data, actions) => {
          return TinabaAPI.confirmPaypalCheckout({ ...data, externalTransactionId: data.orderID })
          .then(async ({ data }) => {
            this.unsetGlobalLoading()
            await this.triggerPoll()
            if (!data.res.ok) {
              this.errorNote = 'Something went wrong'
            }
          })
        }
      }).render(this.$refs.forpaypal)
    }
  },
  mounted () {
    this.initPaypal()
  }
}
</script>